import { render, staticRenderFns } from "./template-deliveryUnit.vue?vue&type=template&id=36e90afc&"
import script from "./template-deliveryUnit.vue?vue&type=script&lang=js&"
export * from "./template-deliveryUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports